<template>
    <div class="panel">
        <div class="panel-heading">
            <div class="panel-label">
                <h3>Order</h3>
            </div>
        </div>
        <div class="panel-body">
            <div class="alert alert-secondary">
                <div class="alert-text"> Order configuration</div>
            </div>
            <div class="col">
                <div class="row form-group">
                    <div class="col-3">
                        <label class="input-label" for="exp">
                            Order expiration time (days)
                        </label>
                    </div>
                    <div class="col-9">
                        <div class="input-group">
                            <input
                                id="exp"
                                ref="form" v-model="days" :min="1" :max="14" :step="1" class="form-control form-control-sm"
                                type="number">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import FormInput from '../../../../Shared/UI/Form/FormInput.vue';

export default {
    name: 'SetupOrderData',
    props: {
        toExpire: {
            type: Object,
            default() {
                return {}
            }
        },
    },
    data() {
        return {
            days: this.toExpire.days || 2
        }
    },
    methods: {
      daysLimit(days){
        if(days >= 14){
          return 14;
        }

        if(days <= 0){
          return 0;
        }

        return days;
      }
    },
    watch: {
        'toExpire.days'(val) {
            this.days = parseInt(val);
        },
        days(days, old) {
            this.days = parseInt(days);
            this.days = days != old ? this.daysLimit(days) : old;
            this.$emit('expire', {
                months: 0,
                days: parseInt(this.days),
                hours: 0,
                minutes: 0,
                seconds: 0,
                miliseconds: 0
            })
        }
    },
    components: {
        FormInput,
    },
}
</script>
